export const FINALIST_ABRV = "FI";
export const LAST_CHANCE_ABRV = "LC";

export type CupModeRoundResult = {
  pointsAtStart: number;
  pointsDelta: number;
  pointsAtEnd: number;
  rosterId: string;
};

export const getForwardCupModeRoundResultDisplayScore = (
  points: number,
  finalist: boolean,
  pointsLimit: number
) => {
  if (finalist && points === pointsLimit) {
    return FINALIST_ABRV;
  }

  return points.toString();
};

export const getReverseCupModeRoundResultDisplayScore = (
  points: number,
  lastChance: boolean
) => {
  if (lastChance && points === 0) {
    return LAST_CHANCE_ABRV;
  }

  return points.toString();
};
